import React from 'react'
import { Button } from 'react-bootstrap'

import './styles.css'

const BtnBack = ({ handleRollback }) => (
    <Button className='btn-back' variant="light" onClick={handleRollback}>
        Voltar
    </Button>
)

export default BtnBack;